var a="Dot";var r="Blank";var e="Rectangle";export{r as TYPE_BLANK_ENDPOINT,a as TYPE_DOT_ENDPOINT,e as TYPE_RECTANGLE_ENDPOINT};
